import { SpriteWithId } from '../../types/typing.ts';

class EffectControl {
  cacheMap: Record<string, SpriteWithId> = {};

  enter(data: {
    id: string;
    src: string;
    startTime: number;
    time: number;
    effectRef: any;
  }) {
    const { id, effectRef } = data;
    let item: SpriteWithId;

    if (this.cacheMap[id]) {
      item = this.cacheMap[id];
      item.visible = true;
    } else {
      effectRef.current.visible = true;
      this.cacheMap[id] = effectRef.current;
    }
  }

  update(data: {
    id: string;
    src: string;
    startTime: number;
    endTime: number;
    time: number;
    effectRef: any;
  }) {
    const { id, startTime, endTime, time } = data;
    const item = this.cacheMap[id];

    if (!item) return;
    if (time > endTime || time < startTime) {
      item.visible = false;
    } else {
      //const cur = time - startTime;
      item.visible = true;
    }
  }

  leave(data: {
    id: string;
    startTime: number;
    endTime: number;
    time: number;
    effectRef: any;
  }) {
    const { id, startTime, endTime, time, effectRef } = data;
    if (!this.cacheMap[id]) {
      this.cacheMap[id] = effectRef.current;
    }
    const item = this.cacheMap[id];
    if (!item) return;
    if (time > endTime || time < startTime) {
      item.visible = false;
    } else {
      //const cur = time - startTime;
      item.visible = true;
      //this._goToAndStop(item, cur);
    }
  }
  destroy() {
    this.cacheMap = {};
  }
}

export default new EffectControl();
